// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiRequestSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiRequestSearchDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalBiRequestSearchDefaultResponseData.discriminator = undefined;
MedicalV1MedicalBiRequestSearchDefaultResponseData.additionalProperties = false;
MedicalV1MedicalBiRequestSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "requests",
        "baseName": "requests",
        "type": ""
    },
];
//# sourceMappingURL=medicalV1MedicalBiRequestSearchDefaultResponseData.js.map